import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../styles/splash.css";

const REDIRECT_URL = "https://kheci-rebrand.vercel.app/";
const DURATION_MS = 1500;
const TICK_INTERVAL_MS = 50;

export default function SplashScreen() {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const startTime = Date.now();

    const interval = setInterval(() => {
      const currentElapsed = Date.now() - startTime;
      if (currentElapsed >= DURATION_MS) {
        setElapsed(DURATION_MS);
        clearInterval(interval);
        window.location.href = REDIRECT_URL;
      } else {
        setElapsed(currentElapsed);
      }
    }, TICK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  const progressPercent = Math.min(100, Math.round((elapsed / DURATION_MS) * 100));
  const remainingSeconds = Math.max(1, Math.ceil((DURATION_MS - elapsed) / 1000));

  return (
    <main className="kheci-splash-container" role="main">
      <Helmet>
        {/* <title>KHECI — Redirecting...</title> */}
        <title>KHECI</title>
        <meta httpEquiv="refresh" content={`5;url=${REDIRECT_URL}`} />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>

      <div className="kheci-splash-content">
        {/* Centered Logo */}
        <div className="kheci-logo-wrap">
          <div className="kheci-logo-glow" aria-hidden="true" />
          <img
            src="/kheci_bgremoved.png"
            alt="KHECI Logo"
            className="kheci-logo-img"
            onError={(e) => {
              if (e.currentTarget.src.indexOf("icon.png") === -1) {
                e.currentTarget.src = "/icon.png";
              }
            }}
          />
        </div>

        {/* Title & Tagline */}
        <p className="kheci-brand-name">Kalimpong Himalayan Edu-Care Institution</p>
        <h1 className="kheci-tagline">
          Empowering Minds.
          <br />
          <span className="kheci-gold-accent">Building Futures.</span>
        </h1>

        <p className="kheci-subline">
          Redirecting you to our new official website...
        </p>

        {/* Single Loading Indicator: Sleek Progress Bar */}
        <div className="kheci-loader-box">
          <div
            className="kheci-progress-track"
            role="progressbar"
            aria-valuenow={progressPercent}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div
              className="kheci-progress-fill"
              style={{ width: `${progressPercent}%` }}
            />
          </div>

          <p className="kheci-redirect-text">
            Redirecting in {remainingSeconds}s
          </p>
        </div>

        {/* Direct Link */}
        <a href={REDIRECT_URL} className="kheci-direct-link">
          <span>Go to new website now</span>
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </main>
  );
}
